class EluxaVideoModal extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.eluxa-video-modal__trigger');
    this.dialog = this.querySelector('.eluxa-video-modal__dialog');
    this.closeButton = this.querySelector('.eluxa-video-modal__close');
    this.player = this.querySelector('.eluxa-video-modal__player');
    this.template = this.querySelector('template');

    if (!this.trigger || !this.dialog || !this.player || !this.template) return;

    this.trigger.addEventListener('click', () => this.open());
    if (this.closeButton) this.closeButton.addEventListener('click', () => this.dialog.close());

    this.dialog.addEventListener('click', (event) => {
      const rect = this.dialog.getBoundingClientRect();
      const inside =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!inside) this.dialog.close();
    });

    this.dialog.addEventListener('close', () => this.stopVideo());
  }

  open() {
    this.player.innerHTML = '';
    this.player.appendChild(this.template.content.cloneNode(true));
    document.body.classList.add('eluxa-video-modal-open');
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  stopVideo() {
    this.player.innerHTML = '';
    document.body.classList.remove('eluxa-video-modal-open');
  }
}

customElements.define('eluxa-video-modal', EluxaVideoModal);
